import styled from "styled-components";

export const Container = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #000000;
    padding: 0 1rem 3rem 1rem;

    h1 {
        color: white;
        margin-bottom: 2rem;
        margin-top: 1rem;
    }

    img {
        margin-bottom: 2.5rem;
        width: 100%;
        max-width: 500px;
    }
`